import ShiftDeclinedReason from "@/models/Shared/ShiftDeclinedReason";

export default class BookingOfferShiftReply {
    bookingRoleWorkerShiftId = '';
	applied:   boolean;
	declinedReason: ShiftDeclinedReason = ShiftDeclinedReason.BOOKING_DECLINED_REASON_UNDEFINED;
}